module.exports = __webpack_public_path__ + "static/media/mobileScreenshot04.6fc70f3f.jpg";